import React from "react";
import Layout from "../components/layout";
import SideBySide from "../components/sidebyside";
import Computer from "../images/computer.webp";
import PersonSitting from "../images/person-sitting-gold.webp";

export default function AboutPage() {
  return (
    <Layout>
      <div className="container about-page">
        <div className="about-hero">
          <h1 className="about-hero__title">About</h1>
          <p className="about-hero__lead">
            I'm Casey—a designer and developer who helps small businesses look
            like they've got their act together (because you do, you just need
            the visuals to match).
          </p>
        </div>

        <section className="about-section">
          <div className="about-section__header">
            <h2 className="about-section__title">What I can help with</h2>
            <p className="about-section__subtitle">
              I do a bit of everything, which means you don't have to hire five
              different people to get a cohesive result.
            </p>
          </div>

          <div className="about-cards">
            <div className="about-card">
              <div className="about-card__title">Brand Identity</div>
              <p className="about-card__text">
                Logos, colors, fonts—all the pieces that make people recognize
                you. I'll build a system that works whether it's on a business
                card or a billboard.
              </p>
            </div>

            <div className="about-card">
              <div className="about-card__title">Web Design + Development</div>
              <p className="about-card__text">
                Websites that look good and actually work. I handle the design
                and the code, so nothing gets lost in translation between "here's
                the mockup" and "here's the live site."
              </p>
            </div>

            <div className="about-card">
              <div className="about-card__title">Packaging + Print</div>
              <p className="about-card__text">
                Labels, menus, signage, business cards—anything that exists in
                the real world. I'll make sure it all feels like it belongs
                together.
              </p>
            </div>

            <div className="about-card">
              <div className="about-card__title">Product Labels</div>
              <p className="about-card__text">
                If you sell something that sits on a shelf, I can design labels
                that stand out and tell your story at a glance.
              </p>
            </div>

            <div className="about-card">
              <div className="about-card__title">CMS Setup</div>
              <p className="about-card__text">
                I'll set up your site so you can update it yourself—no calling
                me every time you need to change a photo or fix a typo.
              </p>
            </div>

            <div className="about-card">
              <div className="about-card__title">Ongoing Site Help</div>
              <p className="about-card__text">
                Don't want to think about your website after it launches? I can
                handle updates, backups, and keeping things running smoothly.
              </p>
            </div>
          </div>
        </section>

        <section className="about-section">
          <div className="about-section__header">
            <h2 className="about-section__title">How it works</h2>
            <p className="about-section__subtitle">
              No 47-page proposals or endless revision rounds. Just a
              straightforward process that gets things done.
            </p>
          </div>

          <SideBySide
            className="mb-4 about-process"
            heading="We start with a conversation"
            subheading="Not a questionnaire."
            img={Computer}
            alt="Laptop and design work"
          >
            I'll ask about your business, your customers, and what you're
            actually trying to accomplish. Then I'll put together a plan that
            makes sense for your budget and timeline.
          </SideBySide>

          <SideBySide
            className="mb-4 about-process"
            heading="Design that earns its place"
            subheading="Nothing's there just because it looks cool."
            img={PersonSitting}
            alt="Illustration of a person sitting"
            inverse
          >
            Every color, font, and layout choice has a reason behind it. The
            goal is always to make things clearer and easier for the people
            you're trying to reach.
          </SideBySide>
        </section>
      </div>
    </Layout>
  );
}
